import React from "react";
import UserStore from "../stores/UserStore";
import connectToStores from "alt-utils/lib/connectToStores";

import GlobalSearch from "./partials/search/global-search.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

class GodLookup extends React.Component {
  constructor(props) {
    super(props);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentDidMount() {}

  getStyles() {
    return {};
  }

  render() {
    let styles = this.getStyles();

    if (!this.props.apiKey) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <h1>God Lookup</h1>
        <p>Find anyone, anything, anywhere.</p>
        <GlobalSearch godMode={true} />
      </div>
    );
  }
}

export default connectToStores(GodLookup);



// WEBPACK FOOTER //
// ./src/app/components/god-lookup.jsx